(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anchor-url"] && !Shopify.designMode) return;
  try {
    /*
    Arriving from another page at a homepage anchor (e.g. /de-de#faq):
    the browser jumps to the anchor at load time, but content above it
    (the Shopify Forms key-finder block, images) finishes loading later and
    pushes the target down. Re-align on late layout growth for up to
    15 seconds; stop as soon as the visitor scrolls or interacts.
  */
  (function () {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id || !('ResizeObserver' in window)) return;
    var target = document.getElementById(id);
    if (!target) return;

    var done = false;
    var corrections = 0;
    var timer;

    // Debounced, only when the target really drifted, at most 10 times —
    // never scroll synchronously inside the observer callback.
    function realign() {
      if (done) return;
      var margin = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
      if (Math.abs(target.getBoundingClientRect().top - margin) > 4) {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        corrections += 1;
        if (corrections >= 10) stop();
      }
    }

    var observer = new ResizeObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(realign, 50);
    });

    function stop() {
      done = true;
      window.clearTimeout(timer);
      observer.disconnect();
    }

    observer.observe(document.body);
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (name) {
      window.addEventListener(name, stop, { once: true, passive: true });
    });
    window.setTimeout(stop, 15000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function close(selector, focusToggle) {
      var toggle = selector.querySelector('[data-country-toggle]');
      var list = selector.querySelector('.country-selector__list');
      if (!toggle || !list || list.hidden) return;
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (focusToggle) toggle.focus();
    }

    document.querySelectorAll('[data-country-selector]').forEach(function (selector) {
      var toggle = selector.querySelector('[data-country-toggle]');
      var list = selector.querySelector('.country-selector__list');
      if (!toggle || !list) return;

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        list.hidden = open;
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (!open) {
          var current = list.querySelector('[aria-current="true"]') || list.querySelector('button');
          if (current) current.focus();
        }
      });

      // Escape closes an open list only; with the list closed it is left to
      // the surrounding dialog (mobile menu).
      selector.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !list.hidden) {
          event.preventDefault();
          event.stopPropagation();
          close(selector, true);
        }
      });

      // Only when focus demonstrably moves elsewhere: Safari does not focus
      // buttons on click/tap (relatedTarget null) and would otherwise close
      // the list before the country button receives the click. Clicks
      // outside are handled by the document listener below.
      selector.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !selector.contains(event.relatedTarget)) close(selector, false);
      });
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-country-selector]').forEach(function (selector) {
        if (!selector.contains(event.target)) close(selector, false);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["key-code-checker"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Format/range check only. Normalization: drop all whitespace (codes
      are pure A–Z/0–9, so a space is never part of a code, e.g.
      "AC 12345") and upper-case (supported systems are not
      case-sensitive). Nothing is added, completed or guessed. The value is
      never stored or sent.
    */
    function evaluate(raw, rule) {
      var value = (raw || '').replace(/\s+/g, '').toUpperCase();
      if (value === '') return 'empty';
      if (!/^[A-Z0-9]+$/.test(value)) return 'format';
      var prefix = null;
      (rule.prefixes || [rule.prefix || '']).forEach(function (candidate) {
        if (value.indexOf(candidate) === 0 && (prefix === null || candidate.length > prefix.length)) {
          prefix = candidate;
        }
      });
      if (prefix === null) return 'mismatch';
      var digits = value.slice(prefix.length);
      if (digits.length !== rule.length || !/^[0-9]+$/.test(digits)) return 'mismatch';
      var number = parseInt(digits, 10);
      if (number < rule.min || number > rule.max) return 'mismatch';
      return 'match';
    }

    window.DSFKeyCode = { evaluate: evaluate };

    function init(root) {
      var prefixes = (root.getAttribute('data-prefix') || '')
        .toUpperCase()
        .split(',')
        .map(function (item) {
          return item.replace(/\s+/g, '');
        })
        .filter(function (item) {
          return /^[A-Z0-9]+$/.test(item);
        });
      if (prefixes.length === 0) prefixes = [''];
      var rule = {
        prefixes: prefixes,
        length: parseInt(root.getAttribute('data-length'), 10),
        min: parseInt(root.getAttribute('data-min'), 10),
        max: parseInt(root.getAttribute('data-max'), 10)
      };
      if (isNaN(rule.length) || isNaN(rule.min) || isNaN(rule.max)) return;

      var input = root.querySelector('[data-key-code-input]');
      var button = root.querySelector('[data-key-code-submit]');
      var states = root.querySelectorAll('[data-state]');

      function show(name) {
        states.forEach(function (el) {
          el.hidden = el.getAttribute('data-state') !== name;
        });
        input.setAttribute('aria-invalid', name === 'match' || name === null ? 'false' : 'true');
      }

      function run() {
        show(evaluate(input.value, rule));
      }

      button.addEventListener('click', run);

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          run();
        }
      });

      input.addEventListener('input', function () {
        show(null);
      });
    }

    document.querySelectorAll('[data-key-code-checker]').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-guarantee-notice]').forEach(function (root) {
    var dialog = root.querySelector('[data-guarantee-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    root.querySelectorAll('[data-guarantee-open]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        dialog.showModal();
      });
    });
    var close = root.querySelector('[data-guarantee-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
